import { createAction, props } from '@ngrx/store';
import { IChannelsData, IChannelsModel } from '@partners/api';

export class ChannelsActions {
  static reset = createAction('[Channels] Reset State');
  static load = createAction('[Channels] Load');
  static loadSuccess = createAction('[Channels] Load Success', props<{ model: IChannelsModel; data: IChannelsData }>());
  static loadFailure = createAction('[Channels] Load Failure', props<{ error: any }>());
  static submit = createAction('[Channels] Submit', props<{ model: IChannelsModel }>());
  static submitSuccess = createAction('[Channels] Submit Success', props<{ data: IChannelsData }>());
  static submitFailure = createAction('[Channels] Submit Failure', props<{ error: any }>());
}
